import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
} from '@mui/material';
import newsData from '../data/NewsData.json';

const News = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        backgroundColor: '#fff',
        minHeight: '100vh',
      }}
    >
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{ mb: 4 }}
      >
        {t('news.title', 'News')}
      </Typography>
      <Grid
        container
        spacing={4}
        justifyContent="center"
        sx={{ maxWidth: 1200, mx: 'auto' }}
      >
        {newsData.slice().reverse().map(({ id, image, text_en, text_es, link }) => {
          const isExternal = link.startsWith('http');
          const finalLink = isExternal ? link : link; // no PUBLIC_URL for internal routes

          return (
            <Grid
              key={id}
              item
              xs={12}
              sm={6}
              md={4}
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              <Card
                sx={{
                  width: '100%',
                  maxWidth: 350,
                  minWidth: 300,
                  height: 400,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  textAlign: 'center',
                }}
              >
                <CardMedia
                  component="img"
                  height="250"
                  image={`${process.env.PUBLIC_URL}${image}`}
                  alt={`news-${id}`}
                  sx={{
                    objectFit: 'cover',
                    width: '100%',
                    borderRadius: 1,
                  }}
                />
                <CardContent sx={{ flexGrow: 1, px: 2, pt: 2 }}>
                  <Typography
                    variant="subtitle2"
                    color="text.primary"
                    sx={{
                      fontWeight: 'bold',
                      display: '-webkit-box',
                      WebkitBoxOrient: 'vertical',
                      WebkitLineClamp: 3,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {language === 'es' ? text_es : text_en}
                  </Typography>
                </CardContent>
                <CardActions sx={{ pb: 2, justifyContent: 'center' }}>
                  <Button
                    size="small"
                    variant="contained"
                    component={isExternal ? 'a' : RouterLink}
                    to={!isExternal ? finalLink : undefined}
                    href={isExternal ? finalLink : undefined}
                    target={isExternal ? '_blank' : undefined}
                    rel={isExternal ? 'noopener noreferrer' : undefined}
                    sx={{
                      backgroundColor: 'black',
                      '&:hover': { backgroundColor: '#333' },
                    }}
                  >
                    {t('news.read_more', 'Read More')}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default News;
